module.exports = __webpack_public_path__ + "media/images/dashboard/google_play_store-e7a739a243daefffa843974047cdce9d.png";